/* v4.4 (2026-07-27): FALLBACK back-in-stock capture on sold-out PDPs.
   The back-in-stock app owns this normally: it injects .gw-float-widget and bx-cart-fix.js
   turns the sold-out CTA into the trigger for its popup. But that widget can take several
   seconds to appear, and if the app ever lapses or fails to load the CTA is left as an inert
   disabled "Sold out" button — with four of five scents and the 100-wash detergent box out of
   stock, that is a lot of demand walking away unrecorded.
   So this waits GRACE ms, and only if the app is still absent does it take the button and post
   straight to Klaviyo's onsite back-in-stock endpoint. Klaviyo's own Back In Stock flow
   (XZ2Bhc) is live and waiting on the "Subscribed to Back in Stock" metric, so the existing
   flow does the rest when Shopify restocks. If the app shows up late, this stands down.
   One email, one purpose — no newsletter opt-in is requested or sent. */
(function () {
  var KEY = (function () {
    var srcs = Array.prototype.map.call(document.querySelectorAll('script[src*="klaviyo"]'), function (s) { return s.src; }).join(' ');
    var m = /onsite\/js\/([A-Za-z0-9]+)\//.exec(srcs);
    return m ? m[1] : '';
  })();
  if (!KEY) return;

  var handle = (location.pathname.split('/products/')[1] || '').split(/[\/?#]/)[0];
  if (!handle) return;

  var GRACE = 6000;            /* give the back-in-stock app a fair chance to load first */
  var started = Date.now();
  var product = null, wired = false;

  function css() {
    if (document.getElementById('mb-bis-css')) return;
    var s = document.createElement('style');
    s.id = 'mb-bis-css';
    s.textContent =
      ".mb-bis{margin:12px 0 0;font-family:'Poppins',system-ui,sans-serif}" +
      ".mb-bis[hidden]{display:none}" +
      ".mb-bis__t{margin:0 0 8px;font-size:12.5px;line-height:1.5;color:#6b5f4d}" +
      ".mb-bis__row{display:flex;gap:8px}" +
      ".mb-bis__input{flex:1;min-width:0;border:1.5px solid #e2d9c6;border-radius:999px;padding:12px 16px;font:inherit;font-size:14px;color:#1c1810;background:#fff;outline:none}" +
      ".mb-bis__input:focus{border-color:#b08741}" +
      ".mb-bis__btn{flex:none;border:0;border-radius:999px;padding:12px 20px;background:#1c1810;color:#fff;font:inherit;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;cursor:pointer}" +
      ".mb-bis__btn[disabled]{opacity:.5;cursor:default}" +
      ".mb-bis__msg{margin:8px 0 0;font-size:12.5px;line-height:1.5;min-height:1em}" +
      ".mb-bis__msg.ok{color:#5d7a4e;font-weight:600}" +
      ".mb-bis__msg.err{color:#b23b3b}";
    (document.head || document.documentElement).appendChild(s);
  }

  function variantNow() {
    if (!product) return null;
    var inp = document.getElementById('bx-variant-id');
    var id = inp ? parseInt(inp.value || '0', 10) : 0;
    var list = product.variants || [];
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list.length === 1 ? list[0] : null;
  }

  function build(btn) {
    var box = document.createElement('div');
    box.className = 'mb-bis';
    box.hidden = true;
    box.innerHTML =
      '<p class="mb-bis__t">We will email you once, the moment it is back. Nothing else.</p>' +
      '<div class="mb-bis__row">' +
      '<input type="email" class="mb-bis__input" inputmode="email" autocomplete="email" placeholder="Your email address" aria-label="Your email address">' +
      '<button type="button" class="mb-bis__btn">Notify me</button>' +
      '</div>' +
      '<p class="mb-bis__msg" role="status" aria-live="polite"></p>';
    (btn.parentNode || document.body).insertBefore(box, btn.nextSibling);

    var input = box.querySelector('.mb-bis__input');
    var send = box.querySelector('.mb-bis__btn');
    var msg = box.querySelector('.mb-bis__msg');

    function submit() {
      var email = (input.value || '').trim();
      msg.className = 'mb-bis__msg';
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        msg.textContent = 'That email address does not look right.';
        msg.classList.add('err');
        input.focus();
        return;
      }
      var v = variantNow();
      if (!v) { msg.textContent = 'Please pick a size first.'; msg.classList.add('err'); return; }
      send.disabled = true;
      send.textContent = 'Sending';
      var body = 'a=' + encodeURIComponent(KEY) +
        '&email=' + encodeURIComponent(email) +
        '&variant=' + encodeURIComponent(String(v.id)) +
        '&product=' + encodeURIComponent(String(product.id)) +
        '&platform=shopify';
      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: body
      })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
        })
        .then(function (res) {
          /* Klaviyo answers 200 on success and 400 with {status, message} on a rejection,
             so trust the HTTP status and only treat an explicit error body as a failure. */
          if (res.ok && !(res.d && res.d.status >= 400)) {
            box.querySelector('.mb-bis__row').style.display = 'none';
            box.querySelector('.mb-bis__t').style.display = 'none';
            msg.textContent = 'Done — we will email you the moment it is back.';
            msg.classList.add('ok');
          } else {
            throw new Error('rejected');
          }
        })
        .catch(function () {
          send.disabled = false;
          send.textContent = 'Notify me';
          msg.textContent = 'That did not go through. Please try again in a moment.';
          msg.classList.add('err');
        });
    }

    send.addEventListener('click', submit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
    return box;
  }

  function appPresent() {
    return !!document.querySelector('.gw-float-widget');
  }

  function apply() {
    var btn = document.getElementById('bx-atc-btn');
    if (!btn || !product) return;

    /* The app owns the CTA whenever it is present, and bx-cart-fix.js marks the button when it
       has wired it up. Either signal means stand down — and hide our form if we got in first. */
    if (appPresent() || btn.getAttribute('data-bx-notify') === '1') {
      var mine = document.querySelector('.mb-bis');
      if (mine) mine.hidden = true;
      return;
    }
    if (Date.now() - started < GRACE) return;

    var v = variantNow();
    var soldOut = product.available === false || (v && v.available === false);
    var box = document.querySelector('.mb-bis');

    if (!soldOut) { if (box) box.hidden = true; return; }

    if (!wired) {
      wired = true;
      css();
      box = build(btn);
      btn.disabled = false;
      btn.removeAttribute('data-bx-soldout');
      btn.textContent = 'Email me when it is back';
      btn.onclick = function (e) {
        e.preventDefault();
        box.hidden = !box.hidden;
        if (!box.hidden) box.querySelector('.mb-bis__input').focus();
        return false;
      };
    } else if (box && btn.textContent.indexOf('Email me') === -1) {
      /* the sold-out guard rewrote the button after a variant switch — take it back */
      btn.disabled = false;
      btn.removeAttribute('data-bx-soldout');
      btn.textContent = 'Email me when it is back';
    }
  }

  fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
    .then(function (p) {
      product = p;
      apply();
      /* variant switches only rewrite a hidden input, and bx-cart-fix re-asserts the button
         on its own 700ms timer — poll just behind it so ours is the state that sticks. */
      setInterval(apply, 900);
    })
    .catch(function () {});
})();
